export function addScriptToPage(url, onSuccess, onError, prepend, scriptId, crossOrigin, removeOnError, async) {
    if (prepend === void 0) { prepend = false; }
    if (crossOrigin === void 0) { crossOrigin = false; }
    if (removeOnError === void 0) { removeOnError = false; }
    if (async === void 0) { async = false; }
    if (!document) {
        return null;
    }
    if (scriptId) {
        var scriptElement = document.getElementById(scriptId);
        if (scriptElement != null) {
            if (onSuccess) {
                onSuccess();
            }
            return scriptElement;
        }
    }
    var script = document.createElement('script');
    script.src = url;
    if (scriptId) {
        script.id = scriptId;
    }
    if (onSuccess) {
        script.onload = onSuccess;
    }
    if (onError) {
        script.onerror = function () {
            var _a;
            onError();
            if (removeOnError) {
                (_a = script.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(script);
            }
        };
    }
    if (crossOrigin) {
        script.crossOrigin = 'anonymous';
    }
    if (async) {
        script.async = true;
    }
    if (prepend) {
        var firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
            return firstScript.parentNode.insertBefore(script, firstScript);
        }
    }
    return document.body.appendChild(script);
}
//# sourceMappingURL=addScriptToPage.js.map